import { render, staticRenderFns } from "./NTSInvClassQuota.vue?vue&type=template&id=953f13c8&scoped=true&"
import script from "./NTSInvClassQuota.vue?vue&type=script&lang=js&"
export * from "./NTSInvClassQuota.vue?vue&type=script&lang=js&"
import style0 from "./NTSInvClassQuota.vue?vue&type=style&index=0&id=953f13c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953f13c8",
  null
  
)

export default component.exports